import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {CpcPerformanceItem} from './performance_items/Cpc'
import {CtrPerformanceItem} from './performance_items/Ctr'
import {CpmPerformanceItem} from './performance_items/Cpm'
import {FrequencyPerformanceItem} from './performance_items/Frequency'
import {VariancePerformanceItem} from './performance_items/Variance'
import {DarkDaysPerformanceItem} from './performance_items/DarkDays'
import {YoyPerformanceItem} from './performance_items/Yoy'
import {UserCountPerformanceItem} from './performance_items/UserCount'

export default class Performance extends Component {
	render() {
		const { scores, showPerformanceModal } = this.props
		return (
			<div className="performance-section">
				<div className="content-wrap">
					<h2>This Is What We Found</h2>
					<div className="performance-items">
						<div className="flex-grid-half">
							<VariancePerformanceItem apiScore={scores.variance} showPerformanceModal={showPerformanceModal} />
							<DarkDaysPerformanceItem apiScore={scores.darkDays} showPerformanceModal={showPerformanceModal} />
						</div>
						<div className="flex-grid-half">
							<FrequencyPerformanceItem apiScore={scores.frequency} showPerformanceModal={showPerformanceModal} />
							<CpmPerformanceItem apiScore={scores.cpm} showPerformanceModal={showPerformanceModal} />
						</div>
						<div className="flex-grid-half">
							<CpcPerformanceItem apiScore={scores.cpc} showPerformanceModal={showPerformanceModal} />
							<CtrPerformanceItem apiScore={scores.ctr} showPerformanceModal={showPerformanceModal} />
						</div>
						<div className="flex-grid-half">
							<YoyPerformanceItem apiScore={scores.yoyGrowth} showPerformanceModal={showPerformanceModal} />
							<UserCountPerformanceItem apiScore={scores.userCount} showPerformanceModal={showPerformanceModal} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}

Performance.propTypes = {
	scores: PropTypes.object,
	showPerformanceModal: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/Performance.js